import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Award } from "lucide-react";
import AOS from "aos";
import "aos/dist/aos.css";
import pic1 from "../../../assets/images/seo.jpg";

const Seo = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="bg-white-100 text-gray-800" style={{ marginTop: "80px" }}>
      <motion.header
        className="bg-blue-900 text-white py-16 text-center shadow-lg rounded-lg"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="bg-gradient-to-r from-blue-50 to-indigo-100 py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                <span className="text-white">
                  🚀 Supercharge Your Online Presence with Proven{" "}
                </span>
                <span className="text-blue-600"> SEO Solutions</span>
              </h1>
              <p className="mt-4 font-bold">
                Drive More Traffic. Improve Visibility. Convert Better.
              </p>
              <p className="text-white mt-4 mb-8">
                At Right On Time Services, we don’t just help you climb the
                search rankings—we help you stay there. Through ethical,
                data-driven SEO strategies, we attract high-quality traffic that
                turns into real business results—without compromising your
                brand’s integrity.
              </p>
              {/* <button
                style={{ color: "black" }}
                className="mt-4 bg-white text-blue-700 px-6 py-3 font-bold rounded-full hover:bg-blue-100 transition"
              >
                Meet Us
              </button> */}
            </div>
          </div>
        </div>
      </motion.header>

      <section
        id="seo-expertise"
        className="py-24 mt-4 mb-4 bg-white px-8 md:px-36"
      >
        <div className="container mx-auto text-center shadow-2xl rounded-2xl p-12">
          <h2 className="text-4xl font-extrabold text-blue-800 mb-6">
            🤝 Partner with Experts Who Understand Organic Growth
          </h2>
          <p className="text-base text-gray-700 mb-4 max-w-3xl mx-auto">
            Search Engine Optimization (SEO) isn’t just about rankings—it’s
            about visibility, credibility, and ROI.
          </p>
          <p className="text-base text-gray-700 mb-4 max-w-3xl mx-auto">
            We specialize in crafting powerful SEO strategies tailored to your
            goals, helping you connect with your ideal customers at the right
            time.
          </p>
          <p className="text-base text-gray-700 max-w-3xl mx-auto">
            Whether you're a startup or an established brand, our experts use
            cutting-edge tools and time-tested techniques to boost your online
            discoverability.
          </p>
        </div>
      </section>

      {/* Why Choose Us? */}
      <section className="py-16 bg-white" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-blue-900 text-center">
          🔍 Our End-to-End SEO Services
        </h2>
        <div
          className="max-w-6xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-8 px-8 mt-6"
          style={{ marginTop: "30px" }}
        >
          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              🧠 Keyword Research & Strategic Analysis
            </h3>
            <p className="mt-2">
              Every successful SEO campaign starts with smart keyword targeting.
              Our team dives deep to find:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
              <li>● High-traffic, low-competition keywords</li>
              <li>● Long-tail keyword opportunities for niche audiences</li>
              <li>
                ● User intent insights to align content with customer behavior
              </li>
              <li>
                ● Competitor keyword analysis to identify gaps and opportunities
              </li>
            </ul>
          </motion.div>
          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              🛠️ On-Page Optimization That Delivers
            </h3>
            <p className="mt-2">
              We fine-tune your website’s core elements to improve searchability
              and user experience, including:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
              <li>● Meta tags (title, description, keywords)</li>
              <li>● Headers and content structure</li>
              <li>● Internal linking strategy</li>
              <li>● Image optimization and URL structures</li>
              <li>● Schema markup for rich snippets</li>
            </ul>
          </motion.div>
          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              ⚙️ Comprehensive Technical SEO Audit
            </h3>
            <p className="mt-2">
              We dig under the hood of your website to eliminate performance
              barriers:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
              <li>● Page speed & performance analysis</li>
              <li>● Mobile-friendliness checks</li>
              <li>● Crawlability and indexability review</li>
              <li>● Broken link detection</li>
              <li>● XML sitemap and robots.txt validation</li>
            </ul>
          </motion.div>
          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              📈 Insightful Reporting & Analytics
            </h3>
            <p className="mt-2">
              We believe in transparency. Our detailed SEO reports show exactly
              how your site is performing:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
              <li>● Keyword rankings & SERP position tracking</li>
              <li>● Website traffic breakdown</li>
              <li>● Conversion metrics and ROI</li>
              <li>● Strategic recommendations for continual improvement</li>
            </ul>
          </motion.div>
        </div>
      </section>

      <motion.div
        className="p-6 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
        // whileHover={{ scale: 1.05 }}
        data-aos="fade-up"
      >
        <section className="py-20 bg-gray-50 px-4 md:px-10" data-aos="fade-up">
          <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8 items-center">
            {/* Left Content */}
            <div>
              <h2 className="text-3xl font-bold text-blue-700 mb-8 text-left">
                🌟 Why Choose Right On Time Services for SEO?
              </h2>
              <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 justify-items-start">
                {[
                  {
                    title: "✅ White-Hat SEO Only",
                    desc: "We follow ethical practices that keep your site safe from penalties and future-proof your rankings.",
                  },
                  {
                    title: "✅ Tailored Strategies",
                    desc: "Your business is unique. We don’t do cookie-cutter SEO—we design strategies just for you.",
                  },
                  {
                    title: "✅ Proven Results",
                    desc: "Our clients enjoy higher visibility, more leads, and measurable growth.",
                  },
                  {
                    title: "✅ Ongoing Optimization",
                    desc: "SEO isn’t one-and-done. We constantly analyze, refine, and improve your performance.",
                  },
                ].map((item, i) => (
                  <div
                    key={i}
                    className="bg-white p-6 rounded-2xl shadow-md w-full max-w-sm text-left"
                  >
                    <h4 className="text-xl font-semibold text-blue-800 mb-2">
                      {item.title}
                    </h4>
                    <p className="text-gray-700 text-sm">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Image */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="flex justify-center"
            >
              <img
                src={pic1} // ← Replace with your actual image path
                alt="SEO services illustration"
                className="w-full max-w-md h-auto object-contain rounded-xl"
              />
            </motion.div>
          </div>
        </section>
      </motion.div>

      {/* Call to Action */}
      <motion.section
        className="py-16 text-center bg-white rounded-lg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        data-aos="fade-up"
      >
        <section className="py-20 bg-white px-4 md:px-10">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-blue-700 mb-6">
              🚀 Ready to Climb the Rankings & Grow Your Business?
            </h2>
            <p className="text-gray-700 text-md mb-4">
              Let us put your brand in front of the people who are already
              searching for what you offer.
            </p>
            <p className="text-gray-700 text-md mb-6">
              With Right On Time Services, SEO becomes a powerful growth engine
              for your business.
            </p>
            <p className="text-lg font-semibold text-blue-800">
              📞 Let’s start your project together — reach out today!
            </p>
          </div>
        </section>
      </motion.section>
    </div>
  );
};

export default Seo;
